var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37,6h-26c-2.762,0 -5,2.238 -5,5v26c0,2.762 2.238,5 5,5h26c2.762,0 5,-2.238 5,-5v-26c0,-2.762 -2.238,-5 -5,-5z",
    fill: "#5dd39e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,11h26v26h-26z",
    fill: "#bafbde"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-13.00408,21.13318) rotate(-44.992)",
    d: "M17.011,20.265h4v12h-4z",
    fill: "#0ca862"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-9.22633,26.01422) rotate(-45.001)",
    d: "M17.789,22.032h18v4.222h-18z",
    fill: "#0ca862"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.c8dc14d651138181f51200e97cffba6c.svg";
export { ForwardRef as ReactComponent };